<template>
    <div id="custom-select" :class="{ 'show-feedback': isInvalid }">
        <vue-multiselect
            :id="id"
            v-model="model"
            label="label"
            trackBy="value"
            :options="options"
            openDirection="bottom"
            :multiple="false"
            :disabled="disabled"
            :placeholder="placeholder"
            :class="{ 'is-valid': isValid, 'is-invalid': isInvalid }"
            :tagPlaceholder="$t('form.multiselect.tagPlaceholder')"
            :selectLabel="$t('form.multiselect.selectLabel')"
            :selectGroupLabel="$t('form.multiselect.selectGroupLabel')"
            :selectedLabel="$t('form.multiselect.selectedLabel')"
            :deselectLabel="$t('form.multiselect.deselectLabel')"
            :deselectGroupLabel="$t('form.multiselect.deselectGroupLabel')"
            :allowEmpty="allowEmpty"
            :showLabels="showLabels"
            :internal-search="internalSearch"
            :loading="loading"
            @input="changedSelectedValue()"
            @search-change="changeSearch"
            @open="$emit('click', $event)"
        >
            <!-- Isso eh o que aparece quando esta selecionado algum item (equivalente ao match do ui-select do v1) -->
            <template slot="singleLabel" slot-scope="{ option }">
                <headlight
                    v-if="isColor(option.color)"
                    :size="headlightSize"
                    :hex="option.color.hex"
                    :title="option.color.title"
                    className="color mr-1"
                />
                <i
                    v-if="option.icon"
                    :class="`fa fa-${option.icon} icon mr-1`"
                ></i>
                <strong class="label">{{ option.label }}</strong>
            </template>

            <!-- Isso eh o que aparece em cada opcao (equivalente ao choices do ui-select do v1) -->
            <template slot="option" slot-scope="{ option }">
                <headlight
                    v-if="isColor(option.color)"
                    :size="headlightSize"
                    :hex="option.color.hex"
                    :title="option.color.title"
                    className="color mr-1"
                />
                <!-- Simula uma arvore quando a opcao depth for diferente de 0, para o caso da selecao de sections -->
                <span :style="{ marginLeft: (option.depth || 0) * 12 + 'px' }">
                    <i
                        v-if="option.icon"
                        :class="`fa fa-${option.icon} icon mr-1`"
                    />
                    <span class="label">{{ option.label }}</span>
                </span>
            </template>
            <span slot="noResult">{{ noElementsFound }}</span>
            <span slot="noOptions">{{ noOptions }}</span>
        </vue-multiselect>
    </div>
</template>

<script>
import VueMultiselect from 'vue-multiselect'
import Headlight from '@/views/components/headlight'
import i18n from '@/i18n'

export default {
    name: 'Select',
    components: {
        VueMultiselect,
        Headlight,
    },
    props: {
        id: {
            type: String,
            default: '',
        },
        options: {
            type: Array,
            default: () => {
                return []
            },
        },
        state: {
            type: Boolean,
            default: null,
        },
        selected: {
            type: Object,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        allowEmpty: {
            type: Boolean,
            default: false,
        },
        showLabels: {
            type: Boolean,
            default: false,
        },
        internalSearch: {
            type: Boolean,
            default: true,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: i18n.t('form.placeholder.select'),
        },
        noElementsFound: {
            type: String,
            default: i18n.t('form.multiselect.noElementsFound'),
        },
        noOptions: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            model: null,
            headlightSize: 12,
        }
    },
    methods: {
        changedSelectedValue() {
            this.$emit('changeValue', this.model)
            this.$emit('update:selected', this.model)
        },
        changeSearch(query) {
            this.$emit('changeSearch', query)
        },
    },
    computed: {
        isColor() {
            return color => color && color.hex && color.title
        },
        isValid() {
            return this.state && this.state !== null
        },
        isInvalid() {
            return !this.state && this.state !== null
        },
    },
    watch: {
        selected(value) {
            this.model = value
        },
    },
}
</script>

<style lang="scss" scope>
@import '@/scss/CustomSelect.scss';
</style>

<style>
.show-feedback ~ .invalid-feedback {
    display: block !important;
}
.label,
.icon,
.color {
    vertical-align: middle;
}
</style>
